const convertArrayOfObjectsToCSV = (array) => {
  let result = '';

  if (array.length === 0) {
      return result; // Devuelve una cadena vacía si el array está vacío
  }

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = Object.keys(array[0]);

  // Construye la primera línea con los nombres de las columnas
  result += keys.join(columnDelimiter);
  result += lineDelimiter;

  // Recorre cada objeto en el array
  array.forEach((item) => {
      let ctr = 0;

      // Recorre cada clave en el objeto
      keys.forEach((key) => {
          if (ctr > 0) result += columnDelimiter;

          // Escapa las comillas dobles en los valores y envuélvelos en comillas si contienen comas
          let fieldValue = item[key];
          
          // Convertir a string y manejar valores especiales
          if (fieldValue === null || fieldValue === undefined) {
              fieldValue = '';
          } else {
              fieldValue = String(fieldValue);
              // Reemplazar saltos de línea con espacios
              fieldValue = fieldValue.replace(/\r?\n|\r/g, ' ');
              // Escapar comillas dobles
              fieldValue = fieldValue.replace(/"/g, '""');
              // Envolver en comillas si contiene comas, comillas o saltos de línea
              if (fieldValue.includes(',') || fieldValue.includes('"') || fieldValue.includes('\n')) {
                  fieldValue = `"${fieldValue}"`;
              }
          }

          result += fieldValue;
          ctr++;
      });

      result += lineDelimiter;
  });

  return result;
};

export default convertArrayOfObjectsToCSV;